import { withPrefix } from "gatsby";

const pathPrefix = withPrefix("/");

export const getFontPath = (fileName: string) =>
  `${pathPrefix}fonts/${fileName}.woff`;

export const getFontFaceSrc = (fileName: string) =>
  `local("ABC Whyte"), url("${getFontPath(fileName)}")`;
